import React, { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { useLocation } from 'react-router-dom'
import { useSelector } from "react-redux";
import axios from 'axios';
import NavbarMob from '../components/NavbarMob'
import Navbar from '../components/Navbar'
import FooterMob from '../components/FooterMob'
import Footer from '../components/Footer'
import filter from '../images/Products/filter.png'
import product1 from '../images/Home/product2.webp'
import heart from '../images/Home/heart.png'
import filledHeart from '../images/Home/heart2.png';
// import cart from '../images/Home/cart.png'
import forward from '../images/Products/forwardpng.png'
import top from '../images/Products/top.png'
import Filter from '../components/Filter'
import { useStore } from '../useStore';


function Products() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const isTab = useMediaQuery({ query: '(max-width: 1024px)' });

    const navigate = useNavigate();
    const home = () => {
        navigate('/')
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const userId = useSelector((state) => state.user.id);
    //('Logged in User ID:', userId);

    const [minPrice, setMinPrice] = useState(70); // Minimum price
    const [maxPrice, setMaxPrice] = useState(600); // Maximum price
    const [showFilter, setShowFilter] = useState(false);
    const [isPriceExpanded, setPriceExpanded] = useState(true);
    const [isColorsExpanded, setIsColorsExpanded] = useState(true);
    const [isSizeExpanded, setIsSizeExpanded] = useState(true);
    const [isDressExpanded, setIsDressExpanded] = useState(true);
    const [showFilterMob, setShowFilterMob] = useState(false);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);
    const [colors, setColors] = useState([]);
    const [sizes, setSizes] = useState([]);
    const [offerPrices, setOfferPrices] = useState({});

    const location = useLocation();
    const { categoryId, categoryName } = location.state || {};
    //("ID", categoryId);
    const { showDropdown, setShowDropdown } = useStore()
    const [loginId, setLoginId] = useState(null);
    const [products, setProducts] = useState([]);
    const [visibleProducts, setVisibleProducts] = useState([]);
    const [wishlistItems, setWishlistItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hasLoadedOnce, setHasLoadedOnce] = useState(false);

    // Pagination states
    const [nextRowOffset, setNextRowOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [totalProducts, setTotalProducts] = useState(0);
    const [currentApiUrl, setCurrentApiUrl] = useState('');
    const PAGE_SIZE = 20;

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    // Refs for caching and mounting
    const imageCacheRef = useRef(new Map());
    const mountedRef = useRef(true);
    const abortControllerRef = useRef(null);

    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, []);


    // Fetch products with availability (logic from SearchPage)
    const fetchProductsWithAvailability = async (isLoadMore = false) => {
        if (!apiBaseUrl || !categoryId) return;

        if (!isLoadMore) {
            // Cancel previous request if any
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const controller = new AbortController();
            abortControllerRef.current = controller;
            const signal = controller.signal;

            setLoading(true);
            setProducts([]); // Clear products to ensure skeleton displays
            setVisibleProducts([]);
            setNextRowOffset(0);
            setHasMore(true);
            setHasLoadedOnce(false); // Reset loaded flag for new category
        } else {
            setIsLoadingMore(true);
        }

        const params = new URLSearchParams();
        params.append('Id', categoryId);
        params.append('minPrice', minPrice);
        params.append('maxPrice', maxPrice);
        if (selectedColor) params.append('color', selectedColor);
        if (selectedSize) params.append('size', selectedSize);

        const currentOffset = isLoadMore ? nextRowOffset : 0;
        const baseUrl = `${apiBaseUrl}/getProductByCategory/BLACKBATON_2526?${params.toString()}`;
        setCurrentApiUrl(baseUrl);

        try {
            const signal = abortControllerRef.current?.signal;
            const response = await axios.get(`${baseUrl}&nextRowOffset=${currentOffset}&pageSize=${PAGE_SIZE}`, {
                signal: signal
            });
            const result = response.data;

            if (result.products && Array.isArray(result.products)) {
                const newProducts = result.products;

                if (isLoadMore) {
                    setProducts(prev => {
                        const existingIds = new Set(prev.map(p => p.ID));
                        const uniqueNew = newProducts.filter(p => !existingIds.has(p.ID));
                        return [...prev, ...uniqueNew];
                    });
                } else {
                    setProducts(newProducts);
                }

                setNextRowOffset(result.pagination?.nextRowOffset || 0);
                setHasMore(result.pagination?.hasMore || false);
                setTotalProducts(result.pagination?.totalProducts || 0);

                setHasLoadedOnce(true); // Set only on successful result processing

                // Display all products immediately
                if (mountedRef.current) {
                    setVisibleProducts(prev => {
                        const newIds = newProducts.map(p => p.ID);
                        return isLoadMore ? [...prev, ...newIds] : newIds;
                    });
                }
            } else {
                setHasLoadedOnce(true); // Also set if we got a valid but empty/non-array result
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                // console.log('Request cancelled:', error.message);
                return;
            }
            console.error('Error fetching products:', error);
        } finally {
            if (mountedRef.current) {
                // Only unset loading if this request wasn't aborted
                if (isLoadMore || (abortControllerRef.current && !abortControllerRef.current.signal.aborted)) {
                    setLoading(false);
                    setIsLoadingMore(false);
                }
            }
        }
    };

    useEffect(() => {
        fetchProductsWithAvailability();
    }, [apiBaseUrl, categoryId]);

    const loadMoreProducts = () => {
        if (hasMore && !isLoadingMore) {
            fetchProductsWithAvailability(true);
        }
    };

    // Infinite Scroll - REMOVED
    // useEffect(() => {
    //     const handleScroll = () => {
    //         if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 1000) {
    //             loadMoreProducts();
    //         }
    //     };
    //     // ...
    // }, []);


    const handleMinChange = (e) => {
        const value = Math.min(Number(e.target.value), maxPrice - 10); // Ensure min < max
        setMinPrice(value);
    };

    const handleMaxChange = (e) => {
        const value = Math.max(Number(e.target.value), minPrice + 10); // Ensure max > min
        setMaxPrice(value);
    };

    const addToWishlist = async (product) => {
        const apiUrl = `${apiBaseUrl}/wishlist/add/BLACKBATON_2526`;

        const activeUserId = loginId || userId; // Use loginId if available, otherwise use userId

        if (!activeUserId) {
            console.error("No valid user ID found.");
            alert("User ID is missing.");
            return;
        }

        const payload = {
            ID: product.ID,
            ItemName: product.ItemName,
            MRP: product.MRP,
            ledcode: activeUserId,  // Use the determined user ID
            Qty: product.Qty
        };

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                //("Added to wishlist:", result);
                // Update the local state
                setWishlistItems(prevItems => [...prevItems, product]);
                alert("Item added to wishlist!");
            } else {
                console.error("Failed to add to wishlist");
                alert("Already in Wishlist");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred while adding to wishlist.");
        }
    };

    useEffect(() => {
        const fetchWishlistItems = async () => {
            try {
                const activeUserId = loginId || userId; // Use loginId if available, otherwise use userId

                if (!activeUserId) return; // Ensure there's a valid userId before making the API call

                const response = await fetch(`${apiBaseUrl}/wishlist/items/BLACKBATON_2526/${activeUserId}`);
                const data = await response.json();

                if (data.success) {
                    setWishlistItems(data.items);
                }
            } catch (error) {
                console.error("Error fetching wishlist items:", error);
            }
        };

        fetchWishlistItems();
    }, [loginId, apiBaseUrl, userId]);

    const removeFromWishlist = async (productId) => {
        try {
            const response = await fetch(`${apiBaseUrl}/wishlist/delete/BLACKBATON_2526/${productId}`, {
                method: 'DELETE',
            });

            if (response.ok) {
                // Update the local state
                setWishlistItems(prevItems => prevItems.filter(item => item.ID !== productId));
                alert('Item removed from wishlist!');
            } else {
                console.error('Failed to remove item from wishlist');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred while removing from wishlist.');
        }
    };


    // useEffect(() => {
    //     const fetchOfferPrices = async () => {
    //         const prices = {};
    //         for (const product of products) {
    //             try {
    //                 const res = await fetch(`${apiBaseUrl}/getOfferByItemId/${product.ID}`);
    //                 if (res.ok) {
    //                     const data = await res.json();
    //                     prices[product.ID] = data.OfferPrice;
    //                 }
    //             } catch (err) {
    //                 console.error(`Error fetching offer for product ${product.ID}`, err);
    //             }
    //         }
    //         setOfferPrices(prices);
    //     };

    //     if (products.length > 0) {
    //         fetchOfferPrices();
    //     }
    // }, [products]);



    const toggleFilter = () => {
        setShowFilter(!showFilter);
    };

    const closeFilter = () => {
        setShowFilter(!showFilter);
    };


    // Toggle function for 'Need Help'
    const togglePrice = () => {
        setPriceExpanded(!isPriceExpanded);
    };

    const toggleColors = () => {
        setIsColorsExpanded(!isColorsExpanded);
    };

    const toggleSize = () => {
        setIsSizeExpanded(!isSizeExpanded);
    };

    const toggleDress = () => {
        setIsDressExpanded(!isDressExpanded);
    };


    const handleFilterClick = () => {
        setShowFilterMob(true);
    };

    const closeFilterMob = () => {
        setShowFilterMob(false);
    };

    function encodeBase64(text) {
        return btoa(text);
    }

    // Encrypt and Navigate with Base64
    const fullimage = (id, itemName) => {
        navigate(`/fullimage?I=${encodeBase64(String(id))}&N=${encodeBase64(itemName)}`, { state: { id, itemName } });
    };

    // const fullimage = (id, itemName) => {
    //     navigate('/fullimage', { state: { id, itemName } });
    // };





    // console.log(availability,'availability');
    // console.log(products,'products');


    return (
        <div className='min-h-screen bg-white text-black font-montserrat' onClick={() => setShowDropdown(false)}>
            {isMobile ? <NavbarMob /> : <Navbar />}

            <div className='w-full max-w-[1440px] mx-auto lg:px-12 px-4 py-8 flex flex-col gap-8 lg:mt-[160px] md:mt-[140px] mt-[60px] pb-20'>
                {/* Breadcrumbs */}
                <div className='flex items-center gap-2 text-sm'>
                    <span className='text-gray-400 cursor-pointer hover:text-black transition-colors' onClick={home}>Home</span>
                    <span className='text-gray-300'>/</span>
                    <span className='text-black font-semibold'>{categoryName}</span>
                </div>

                <div className='flex flex-col lg:flex-row gap-10'>
                    {/* Desktop Sidebar Filter */}
                    {showFilter && (
                        <aside className='hidden lg:flex flex-col w-[280px] shrink-0 gap-8'>
                            <div className='flex items-center justify-between pb-4 border-b border-gray-100'>
                                <h2 className='text-xl font-bold'>Filters</h2>
                                <button onClick={closeFilter} className='text-gray-400 hover:text-black'>
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" /></svg>
                                </button>
                            </div>

                            {/* Price Filter */}
                            <div className='flex flex-col gap-4'>
                                <div className='flex items-center justify-between cursor-pointer group' onClick={togglePrice}>
                                    <h3 className='font-bold group-hover:text-gray-600 transition-colors'>Price Range</h3>
                                    <svg className={`w-4 h-4 transition-transform duration-300 ${isPriceExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" /></svg>
                                </div>
                                {isPriceExpanded && (
                                    <div className='flex flex-col gap-6 pt-2'>
                                        <div className='relative h-2 w-full bg-gray-100 rounded-full overflow-hidden'>
                                            <div
                                                className='absolute h-full bg-black'
                                                style={{ left: `${(minPrice / 10000) * 100}%`, right: `${100 - (maxPrice / 10000) * 100}%` }}
                                            />
                                        </div>
                                        <div className='flex items-center justify-between gap-4'>
                                            <div className='flex-1 p-2 bg-gray-50 border border-gray-100 rounded-lg text-center text-sm font-semibold'>₹{minPrice}</div>
                                            <div className='flex-1 p-2 bg-gray-50 border border-gray-100 rounded-lg text-center text-sm font-semibold'>₹{maxPrice}</div>
                                        </div>
                                        <button
                                            onClick={() => fetchProductsWithAvailability()}
                                            className='w-full py-2 bg-black text-white text-sm font-bold rounded-lg hover:bg-gray-800 transition-all'
                                        >
                                            Apply Price
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* Add more filter sections here if needed */}
                        </aside>
                    )}

                    {/* Product Grid Area */}
                    <main className='flex-1'>
                        {loading || !hasLoadedOnce ? (
                            <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-10'>
                                {[...Array(4)].map((_, i) => (
                                    <div key={i} className='flex flex-col gap-4 animate-pulse' style={{ opacity: 1 - i * 0.25 }}>
                                        <div className='aspect-[3/4] bg-gray-100 rounded-2xl' />
                                        <div className='h-4 w-3/4 bg-gray-100 rounded-full' />
                                        <div className='h-4 w-1/4 bg-gray-100 rounded-full' />
                                    </div>
                                ))}
                            </div>
                        ) : products.length === 0 ? (
                            <div className='flex flex-col items-center justify-center py-20 text-center gap-4'>
                                <div className='w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center'>
                                    <svg className="w-8 h-8 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
                                </div>
                                <p className='text-gray-500 font-medium'>No products found in this category.</p>
                                <button onClick={() => navigate('/')} className='text-sm font-bold border-b-2 border-black pb-1'>Back to Home</button>
                            </div>
                        ) : (
                            <div className='flex flex-col gap-12'>
                                <div className={`grid gap-x-5 gap-y-10 ${showFilter ? "grid-cols-2 md:grid-cols-2 lg:grid-cols-3" : "grid-cols-2 md:grid-cols-3 lg:grid-cols-4"}`}>
                                    {products.map((product) => {
                                        const isVisible = visibleProducts.includes(product.ID);
                                        const isInWishlist = wishlistItems.some(item => item.ID === product.ID);

                                        return (
                                            <div key={product.ID}
                                                className={`group flex flex-col gap-3 cursor-pointer transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                                                onClick={() => fullimage(product.ID, product.ItemName)}
                                            >
                                                <div className='relative aspect-[3/4] rounded-2xl bg-[#F5F5F7] overflow-hidden'>
                                                    <img
                                                        src={`${apiLocalUrl}/uploads/${product.displayFirst}.webp?v=${product.UniqueCode}`}
                                                        alt={product.ItemName}
                                                        className='w-full h-full object-cover transition-transform duration-700 group-hover:scale-105'
                                                        loading="lazy"
                                                    />
                                                    <button
                                                        className={`absolute top-4 right-4 w-10 h-10 rounded-full shadow-sm flex items-center justify-center transition-all ${isInWishlist ? 'bg-black text-white' : 'bg-white/80 backdrop-blur-sm text-black hover:bg-white'}`}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            isInWishlist ? removeFromWishlist(product.ID) : addToWishlist(product);
                                                        }}
                                                    >
                                                        <img src={isInWishlist ? filledHeart : heart} alt="wishlist" className={`w-5 h-5 ${isInWishlist ? 'brightness-0 invert' : ''}`} />
                                                    </button>
                                                </div>
                                                <div className='flex flex-col gap-1 font-montserrat'>
                                                    <h3 className='text-left text-sm font-semibold truncate group-hover:text-red-600 underline-offset-4'>{product.ItemName}</h3>
                                                    <div className='flex items-center gap-2'>
                                                        <span className='font-bold'>₹{product.MRP}</span>
                                                        {/* {product.MOP > 0 && product.MOP < product.MRP && (
                                                            <span className='text-xs text-gray-400 line-through'>₹{product.MOP}</span>
                                                        )} */}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                {isLoadingMore && (
                                    <div className='flex justify-center py-8'>
                                        <div className='w-8 h-8 border-4 border-black border-t-transparent rounded-full animate-spin' />
                                    </div>
                                )}

                                {!isLoadingMore && hasMore && (
                                    <div className='flex justify-center py-8'>
                                        <button
                                            onClick={loadMoreProducts}
                                            className='px-8 py-3 bg-black text-white text-sm font-bold rounded-full hover:bg-gray-800 transition-all transform hover:scale-105 shadow-lg'
                                        >
                                            Load More Products
                                        </button>
                                    </div>
                                )}

                                {/* {!hasMore && (
                                    <div className='text-center py-10 border-t border-gray-100'>
                                        <p className='text-gray-400 text-sm italic'>End of collection</p>
                                    </div>
                                )} */}
                            </div>
                        )}
                    </main>
                </div>
            </div>

            {showFilterMob && <Filter closeFilterMob={closeFilterMob} />}
            {isTab ? <FooterMob /> : <Footer />}
        </div>
    );
}

export default Products;
